import { Box, Button, Icon } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import DurationInput from 'modules/core/components/DurationInput'
import i18n from 'modules/core/lib/i18n'

import BreakTypeSelector from 'modules/attendance/components/SettingItemPage/TimeTracking/BreakSettings/AutomaticBreakSettings/AutomaticRules/BreakTypeSelector'
import type AutomaticRuleForm from 'modules/attendance/components/SettingItemPage/TimeTracking/BreakSettings/AutomaticBreakSettings/AutomaticRules/form'
import type RuleForm from 'modules/attendance/components/SettingItemPage/TimeTracking/BreakSettings/AutomaticBreakSettings/AutomaticRules/form'
import { TimeSettingsBreakConfigs } from 'modules/attendance/hooks/useFetchTimeSettingsBreakConfigurations'

interface Props {
  form: RuleForm
  onAdd: () => void
  onDelete: (form: AutomaticRuleForm) => void
  timeSettingsBreakConfigurations: TimeSettingsBreakConfigs[]
  onChange: (newValue: string) => void
  selectedBreakType: string
  label: string
  canAdd: boolean
  rulesSize: number
  attendanceSettingId: string
}

const RuleItem = ({
  form,
  onAdd,
  onDelete,
  label,
  canAdd,
  rulesSize,
  timeSettingsBreakConfigurations,
  selectedBreakType,
  onChange,
  attendanceSettingId,
}: Props) => {
  const periodLengthInMinutes = form.get('periodLength').value
    ? Math.round(form.get('periodLength').value * 60)
    : 0
  const breakDurationInMinutes = form.get('breakDuration').value || 0

  const handlePeriodLengthChange = (minutes: number) => {
    const hours = minutes / 60
    form.get('periodLength').set(hours)
  }

  const handleBreakDurationChange = (minutes: number) => {
    form.get('breakDuration').set(minutes)
  }

  return (
    <Box gap="s8" flexDirection="column" justifyContent="flexStart">
      <BreakTypeSelector
        timeSettingsBreakConfigurations={timeSettingsBreakConfigurations}
        value={selectedBreakType}
        onChange={onChange}
        attendanceSettingId={attendanceSettingId}
      />
      <Box gap="s6" flexDirection="row" alignItems="center" justifyContent="flexStart">
        <DurationInput
          label={label}
          minutes={periodLengthInMinutes}
          onChange={handlePeriodLengthChange}
        />
        <Box paddingTop="s24">
          <Icon.Medium icon="arrow-right" />
        </Box>
        <DurationInput
          label={i18n.t('time_tracking.settings.breaks.instance.automatic_rules.break_time')}
          minutes={breakDurationInMinutes}
          onChange={handleBreakDurationChange}
        />
        <Box width="s24" paddingTop="s24" flexDirection="row" gap="s4">
          <Button
            type="secondary"
            disabled={rulesSize === 1}
            iconName="delete"
            onClick={() => onDelete(form)}
          />
          {canAdd && (
            <Button
              type="secondary"
              onClick={() => onAdd()}
              disabled={!form.get('periodLength').value || !form.get('breakDuration').value}
              iconName="add"
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default observer(RuleItem)
